import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeLatest } from 'redux-saga/effects';
import { SpaceTab } from 'api/space/space-tab';
import { FetchStatus } from 'data/core';
import { saveNormalizedTask } from 'data/tasks/slice';
import { spaceTabSuccessSagaAction } from '../actions';
import { saveNormalizedSpaceTabs } from '../index';
import { spaceTabNormalizer } from '../schema';

function* spaceTabSuccessSaga({ payload }: PayloadAction<SpaceTab>) {
  const {
    entities: { spaceTabs, tasks },
  } = spaceTabNormalizer(payload);

  if (tasks) {
    yield put(
      saveNormalizedTask({ data: tasks, fetchStatus: FetchStatus.Partial }),
    );
  }
  if (spaceTabs) {
    yield put(
      saveNormalizedSpaceTabs({
        data: spaceTabs,
        fetchStatus: FetchStatus.Loaded,
      }),
    );
  }
}

export function* watchSpaceTabSuccessSaga(): Generator {
  yield takeLatest(spaceTabSuccessSagaAction.type, spaceTabSuccessSaga);
}
